function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M39.404 30.816l9.528 9.527-9.528 9.527",
  stroke: "#001A5A",
  strokeWidth: 2.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "arrow-shaft",
  d: "M48.932 40.343H29.877",
  stroke: "#001A5A",
  strokeWidth: 2.5
});

function SvgArrowButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpT0RBaUlHaGxhV2RvZEQwaU9EQWlJSFpwWlhkQ2IzZzlJakFnTUNBNE1DQTRNQ0lnWm1sc2JEMGlibTl1WlNJZ2VHMXNibk05SW1oMGRIQTZMeTkzZDNjdWR6TXViM0puTHpJd01EQXZjM1puSWo0S1BIQmhkR2dnWkQwaVRUTTVMalF3TkRVZ016QXVPREUxT0V3ME9DNDVNekU1SURRd0xqTTBNekZNTXprdU5EQTBOU0EwT1M0NE56QTFJaUJ6ZEhKdmEyVTlJaU13TURGQk5VRWlJSE4wY205clpTMTNhV1IwYUQwaU1pNDFJaTgrQ2p4d1lYUm9JR05zWVhOelBTSmhjbkp2ZHkxemFHRm1kQ0lnWkQwaVRUUTRMamt6TVRrZ05EQXVNelF6TVVneU9TNDROemN5SWlCemRISnZhMlU5SWlNd01ERkJOVUVpSUhOMGNtOXJaUzEzYVdSMGFEMGlNaTQxSWk4K0Nqd3ZjM1puUGdvPSI=";
export { SvgArrowButton as ReactComponent };